import React, {useCallback} from "react";
import {useForm} from "react-hook-form";
import {usePromiseTracker} from "react-promise-tracker";
import {Subject} from "rxjs";
import {showToast} from "common";
import {useObservable} from "rxsupport";
import {ReportModal} from "../../form-components/ReportModal";
import {AuthReviewNeededInput} from "../../domain";
import {AuthReviewNeededForm} from "./AuthReviewNeededForm";

type Props = {
    visible$: Subject<boolean>;
    onFinished: (formValues: AuthReviewNeededInput | null) => Promise<void>;
};

export function AuthReviewNeededFormModal({visible$, onFinished}: Props) {
    const visible = useObservable(visible$, false);

    const methods = useForm<AuthReviewNeededInput>({
        defaultValues: {
            authReviewFromDate: "",
            authReviewToDate: "",
            requestedExtensionDate: null,
            rationaleForDelay: "",
            firstScheduledAssessment: null,
            authorizationReviewReasons: "",
            comments: ""
        }
    });


    const {promiseInProgress} = usePromiseTracker();

    const onCancel = useCallback(async () => {
        showToast.warning(`Submission for Auth Review Needed is cancelled`);
        methods.reset();
        visible$.next(false);
    }, [methods, visible$]);


    return (
        <ReportModal visible={visible} title={'Authorization Review Needed'} onClose={onCancel}>
            <AuthReviewNeededForm visible$={visible$} methods={methods} onFinished={onFinished} onCancel={onCancel}
                                  externalLoading={promiseInProgress}/>
        </ReportModal>
    );
}
